"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HtmlToReactTransformer = void 0;
var HtmlToReactTransformer_1 = require("./HtmlToReactTransformer");
Object.defineProperty(exports, "HtmlToReactTransformer", { enumerable: true, get: function () { return HtmlToReactTransformer_1.HtmlToReactTransformer; } });
//# sourceMappingURL=index.js.map